import React from 'react';
import OfflineIcon from '@assets/icons/offline-agent-icon.svg';
const AgentFormatter = ({ value }) => {
  if (value !== null && value !== undefined && value.localeCompare('') !== 0) {
    const agentList = value.split(';');
    if (agentList[1] && agentList[1].localeCompare('1') === 0) {
      return (
        <div align='center' className='text-center'>
          <img src={OfflineIcon} alt='' />
          {agentList[0]}
        </div>
      );
    }
    return (
      <div align='center' className='text-center'>
        {agentList[0]}
      </div>
    );
  }
  return (
    <div align='center' className='text-center'>
      {value}
    </div>
  );
};
export default React.memo(AgentFormatter);
//Original code:
/*import React from "react";
import OfflineIcon from "@assets/icons/offline-agent-icon.svg";

class AgentFormatter extends React.Component {

  render() {
    console.log("AgentFormatter render", this.props.value);
    if(this.props.value!==null && this.props.value!==undefined && this.props.value.localeCompare("")!==0){
        var agentList=this.props.value.split(";");
        if(agentList[1] && agentList[1].localeCompare("1") === 0)
            return (<div align="center" className="text-center" ><img src={OfflineIcon}/>{agentList[0]}</div>);
        else
            return (<div align="center" className="text-center" >{agentList[0]}</div>);
    }else{
        return (<div align="center" className="text-center" >{this.props.value}</div>);
    }
  }
}

export default AgentFormatter;
*/
